'use client'

import { SmallMediaCard } from '@news12/storybook-news'

import React, { useCallback, useEffect, useState } from 'react'

import { trackGTMEvent } from '../../config/analytics'
import { StoryPreview } from '../../types'
import { getFormattedRelativeTime } from '../../utils/date'
import { getDuration } from '../../utils/duration'

export type MoreStoriesCardProps = StoryPreview & {
  orderNumber: number
}

const MoreStoriesCard = ({
  durationTime,
  title,
  thumbnail,
  href,
  updatedAt = '',
  orderNumber
}: MoreStoriesCardProps) => {
  const handleSmallMediaCardClick = useCallback(() => {
    trackGTMEvent.gaMoreStoriesMediaCardClick(orderNumber, title)
  }, [orderNumber, title])

  const [clientDuration, setClientDuration] = useState<string | null>(null)
  const [clientRelativeTime, setClientRelativeTime] = useState<string>('')

  useEffect(() => {
    setClientDuration(getDuration(durationTime))
    setClientRelativeTime(getFormattedRelativeTime(updatedAt))
  }, [durationTime, updatedAt])

  if (!clientDuration || !clientRelativeTime) return null
  return (
    <SmallMediaCard
      durationTime={clientDuration}
      thumbnail={{ src: thumbnail, alt: title }}
      heading={title}
      href={href}
      updatedAt={clientRelativeTime}
      onClick={handleSmallMediaCardClick}
    />
  )
}

export default MoreStoriesCard
